"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LEFT_PANEL_WIDTH = void 0;
exports.LEFT_PANEL_WIDTH = 548;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY29uc3RhbnRzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vdXRpbHMvY29uc3RhbnRzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFhLFFBQUEsZ0JBQWdCLEdBQUcsR0FBRyxDQUFDIiwic291cmNlc0NvbnRlbnQiOlsiZXhwb3J0IGNvbnN0IExFRlRfUEFORUxfV0lEVEggPSA1NDg7XG4iXX0=